import { render, staticRenderFns } from "./ChannelInfo.vue?vue&type=template&id=1aca76da&scoped=true&lang=pug"
import script from "./ChannelInfo.vue?vue&type=script&lang=js"
export * from "./ChannelInfo.vue?vue&type=script&lang=js"
import style0 from "./ChannelInfo.vue?vue&type=style&index=0&id=1aca76da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aca76da",
  null
  
)

export default component.exports